import { render, staticRenderFns } from "./Rollen.vue?vue&type=template&id=7408ccdc&scoped=true"
import script from "./Rollen.vue?vue&type=script&lang=js"
export * from "./Rollen.vue?vue&type=script&lang=js"
import style0 from "./Rollen.vue?vue&type=style&index=0&id=7408ccdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7408ccdc",
  null
  
)

export default component.exports